var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.eventosWeb)?_c('div',{staticClass:"jumbotron no_space dmbs-container"},[_c('h2',[_vm._v(_vm._s(_vm.filtroActual)+" ")]),_c('pre',[_vm._v("\n    "+_vm._s(_vm.$route)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }